import "babel-polyfill";
import './config/global/mobile.index'
import Vue from 'vue'
import App from './App'
import router from './config/router/mobile.index'
import store from './config/store/index';
import './shared/vue/directives'
import {AppConsts} from "cf/packages/abpVue/AppConsts";
import AppPreBootstrap from 'cf/packages/abpVue/AppPreBootstrap'
import {Toast, Dialog} from 'vant';
import Mobile from '@/assets/Mobile.js'
import UrlHelper from 'cf/packages/abpVue/helpers/UrlHelper.js'

if (UrlHelper.getQueryParameters().debug) {
  clearAllCookie();
}


// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.use(vConsole)


//清除所有cookie函数
function clearAllCookie() {
  var date = new Date();
  date.setTime(date.getTime() - 10000);
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  console.log("需要删除的cookie名字：" + keys);
  if (keys) {
    for (var i = keys.length; i--;)
      document.cookie = keys[i] + "=0; expire=" + date.toGMTString() + "; path=/";
  }
}

window.HELP_IMPROVE_VIDEOJS = false;

AppConsts.isMobile = AppPreBootstrap.isMobile = true;
if (navigator.userAgent.indexOf('CordovaApp') >= 0) {
  var cordovaScript = document.createElement('script');
  cordovaScript.setAttribute('type', 'text/javascript');
  let u = navigator.userAgent;
  //判断浏览器类型
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) {
    cordovaScript.setAttribute('src', 'static/cordova/android/cordova.js')
  }
  if(isiOS){
    cordovaScript.setAttribute('src', 'static/cordova/ios/cordova.js')
  }

  document.body.appendChild(cordovaScript)
}

AppPreBootstrap.run(() => {
  abp.utils.setCookieValue("role", "001");
  router.base = AppConsts.subDirectory;
  window.vm = new Vue({
    el: "#app",
    router: router,
    store: store,
    render: h => h(App),
  })

  abpImplemented();

  if (Mobile.isYzjApp()) {
    Mobile.defBack();

    if (AppConsts.show_header) {
      Mobile.HideHeader();
    }
  }

  if (Mobile.isDD() && AppConsts.dingding_platform) {
    if (abp.auth.getToken()) {
      Mobile.initDD();
    }
  }

  if (Mobile.isWxApp() && AppConsts.wechat_platform) {
    if (abp.auth.getToken()) {
      Mobile.initWechat();
    }
  }
})


function abpImplemented() {
  /*
   重写abp的message
   */

  //实现abp接口
  /* NOTIFICATION *********************************************/
  abp.notify = {
    async success(message, title, options) {
      return Toast.success(message);
    },
    async info(message, title, options) {
      return Toast(message);
    },
    async warn(message, title, options) {
      return Toast(message);
    },
    async error(message, title, options) {
      return Toast.fail(message);
    },
  };
  /* MESSAGE **************************************************/
  abp.message = {
    success(message, title, options) {
      return Dialog.alert({
        title: title || "成功", message: message
      });
    },
    info(message, title, options) {
      return Dialog.alert({
        title: title || "提示", message: message
      });
    },
    warn(message, title, options) {
      return Dialog.alert({
        title: title || "警告", message: message
      });
    },
    error(message, title, options) {
      return Dialog.alert({
        title: title || "错误", message: message
      });
    },
    confirm(message, title, options) {
      return Dialog.confirm({
        title: title || "确认", message: message
      });
    }
  };

}




// WEBPACK FOOTER //
// ./src/mobile.main.js